import { render, staticRenderFns } from "./OtherPayment.vue?vue&type=template&id=d1db2cd6&scoped=true&"
import script from "./OtherPayment.vue?vue&type=script&lang=js&"
export * from "./OtherPayment.vue?vue&type=script&lang=js&"
import style0 from "./OtherPayment.vue?vue&type=style&index=0&id=d1db2cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1db2cd6",
  null
  
)

export default component.exports